module.exports = __webpack_public_path__ + "static/media/bells.a3853626.svg";